import { Hint } from "../../components/Hint";
import { StatusPill } from "../../components/ui";
import { useFormat } from "../../lib/useFormat";

/** #448: the mark on a contact Connect's testing feature made. */
export function TestPill() {
  return <StatusPill status="test" tone="neutral" />;
}

/**
 * #448: the test traffic as its own labeled figure beside the real numbers, and the way to view it alone.
 * Says nothing while there is none and it is not being viewed.
 */
export function TestTrafficFigure({ count, viewing, onToggle }: { count: number; viewing: boolean; onToggle?: (viewTest: boolean) => void }) {
  const fmt = useFormat();
  if (count === 0 && !viewing) return null;
  return (
    <p className="flex flex-wrap items-center gap-2 text-sm text-neutral-600 dark:text-neutral-400">
      <TestPill />
      <span>
        {viewing ? "Showing test traffic only" : "Test traffic"}: {fmt.count(count, "contact", "contacts")}
        <Hint id="journeys.test-traffic" label="test traffic" />
      </span>
      {onToggle && (
        <button type="button" onClick={() => onToggle(!viewing)} className="min-h-9 rounded px-2 text-sm font-medium text-accent-strong underline hover:bg-neutral-50 dark:text-accent dark:hover:bg-neutral-800">
          {viewing ? "Back to real traffic" : "View test traffic alone"}
        </button>
      )}
    </p>
  );
}
